import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ItemServicoListarComponent } from './item-servico-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: ItemServicoListarComponent }
    ])],
    exports: [RouterModule]
})
export class ItemServicoListarRoutingModule { }
